import { render, staticRenderFns } from "./Albumes.vue?vue&type=template&id=611aabd6"
import script from "./Albumes.vue?vue&type=script&lang=js"
export * from "./Albumes.vue?vue&type=script&lang=js"
import style0 from "./Albumes.vue?vue&type=style&index=0&id=611aabd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports